import React from "react";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  useTheme,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

import { STATE_RULES } from "../constants";

const RenderRules = ({ rules }) => {
  const { palette } = useTheme();
  return (
    <List>
      {rules?.map(({ state, label }) => {
        const color = palette.rules[state];
        return (
          <ListItem disablePadding key={label}>
            <ListItemIcon>
              {state !== STATE_RULES.WRONG ? (
                <CheckCircleIcon sx={{ color }} />
              ) : (
                <CloseOutlinedIcon sx={{ color }} />
              )}
            </ListItemIcon>
            <ListItemText
              primary={label}
              sx={{ color: palette.rules.normal }}
            />
          </ListItem>
        );
      })}
    </List>
  );
};

export default RenderRules;
